﻿VoterFly.Util = {
    getXHRApiResponseHtml(message, xhrResponse) {

        const contentType = xhrResponse.getResponseHeader("content-type");
        if (xhrResponse.responseJSON) {
            if (contentType.indexOf('application/problem+json') != -1) {
                if (xhrResponse.responseJSON.errors) {
                    // Parse validation errors and present them to the user
                    const errorMessages = [];
                    for (const propertyName in xhrResponse.responseJSON.errors) {
                        if (xhrResponse.responseJSON.errors.hasOwnProperty(propertyName)) {
                            if (propertyName) {
                                errorMessages.push(`${propertyName}: ${xhrResponse.responseJSON.errors[propertyName].join(', ')}`);
                            } else {
                                errorMessages.push(xhrResponse.responseJSON.errors[propertyName].join(', '));
                            }
                        }
                    }
                    const errorMessage = errorMessages.join('<br/>');
                    // Present errorMessage to the user (e.g., display in an alert or show on the UI)
                    message += ' ' + errorMessage;
                } else {
                    // Handle other response data
                }
            } else if (contentType.indexOf('application/vnd.domain-result+json') != -1) {
                const domainResult = xhrResponse.responseJSON;
                message += ' ' + domainResult.message;
                if (domainResult.errors) {
                    message += '<ul>';
                    message += domainResult.errors.map(error => `<li>${error}</li>`);
                    message += '</ul>';
                }
            } else {
                if (xhrResponse.responseJSON.message) {
                    message += " " + data.responseJSON.message;
                }
            }
        }

        message = message.trim();

        return message;
    }
}